import {
  BusinessDocumentDrawerShell,
  type BusinessDocumentFetcherRenderProps,
} from '@/components/InvoiceReportDetailDrawer/BusinessDocumentDrawerShell';
import { useInvoiceReportsSearchRefetch } from '@/components/InvoiceReportDetailDrawer/context/InvoiceReportsSearchRefetchContext';
import { Contents } from '@/components/InvoiceReportDetailDrawer/FileInfoDrawer/Contents';
import { useInvoiceReportBusinessDocumentService } from '@/context/services/invoice_reports/InvoiceReportBusinessDocument.service';
import { FC, memo } from 'react';

type Props = {
  onCloseDetailDrawer?: () => void;
};

type FetcherProps = BusinessDocumentFetcherRenderProps & {
  onCloseDetailDrawer?: () => void;
};

const Fetcher: FC<FetcherProps> = memo(
  ({ businessDocumentId, onFileNameLoaded, onCloseDetailDrawer }) => {
    const { data: businessDoc, error } =
      useInvoiceReportBusinessDocumentService(businessDocumentId);
    const fnCheckPermission = useInvoiceReportsSearchRefetch();

    return (
      <Contents
        businessDoc={businessDoc}
        error={error}
        onFileNameLoaded={onFileNameLoaded}
        onCloseDetailDrawer={onCloseDetailDrawer}
        fnCheckPermission={fnCheckPermission}
      />
    );
  }
);
Fetcher.displayName = 'InvoiceReportBusinessDocumentFetcher';

export const BusinessDocumentDrawerContainer: FC<Props> = memo(
  ({ onCloseDetailDrawer }) => {
    return (
      <BusinessDocumentDrawerShell>
        {({ businessDocumentId, onFileNameLoaded }) => (
          <Fetcher
            businessDocumentId={businessDocumentId}
            onFileNameLoaded={onFileNameLoaded}
            onCloseDetailDrawer={onCloseDetailDrawer}
          />
        )}
      </BusinessDocumentDrawerShell>
    );
  }
);
BusinessDocumentDrawerContainer.displayName = 'BusinessDocumentDrawerContainer';
